module.exports = __webpack_public_path__ + "static/cargo-4b277cb01113af4f5e4ea6da47299164.jpg";